import spacing from 'material-ui/styles/spacing';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

export const theme = {
  spacing: spacing,
  fontFamily: 'Open Sans',
};

export const muiTheme = getMuiTheme(theme);



// WEBPACK FOOTER //
// ./src/core/theme.js